/**
 * 检测第三方账号是否已经绑定过
 */
import PbAjax from '../../../lib/pbajax';
import url from 'c-url';
import publicpb from '../../../base/public.pb';
import findPwdPb from './userfindpassword.pb';

let pbajax = new PbAjax();

class FindPwd {

    constructor(data = {}) {
        this.promise = this.findPwd(data);
    }

    findPwd(data) {
        let defer = $.Deferred();
        const { Request, Response } = findPwdPb.User.FindPassword;

        let businessData = new Request(data);
        
        let requestData = {
            service: 'service',
            api: '/user/find/password',
            header: {
                'Accept-Language': UP.Global.siteLanguage
            }
        }

        pbajax.do(
            requestData,
            businessData,
            function(res) {
                let dataWrap = publicpb.Result.decode(res);
                
                if (dataWrap.code == 1) { // 已绑定过
                    defer.resolve(true);
                } else {
                    defer.reject(dataWrap);
                }
            },
            () => {
                defer.reject();
            },
            () => {
                defer.reject();
            });
        return defer.promise();
    }
}

export default FindPwd;


// WEBPACK FOOTER //
// ./js/component/email-login/findpwd/findpwd.js